import {
	Checkbox,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TablePagination,
	TableRow,
	TableSortLabel,
	Tooltip,
} from '@material-ui/core';
import { Delete, Phone } from '@material-ui/icons';
import Email from '@material-ui/icons/Email';
import React, { useEffect, useState } from 'react';
import { useComponentVisible } from '../../../hooks/use-component-visible';
import LeadsItem from './LeadsItem';
import styles from './LeadsTable.module.scss';
import { getSalesAgents } from '../../../redux/deals/action';
import { openModal, closeModal } from '../../../redux/modals/action';
import { connect } from 'react-redux';
import LeadDetailsModal from './LeadDetailsModal/LeadDetailsModal';
import ScheduleMeeting from '../../agenda/scheduleMeeting/ScheduleMeeting';
import Loading from '../../layout/loading/Loading';
import { checkRolesAccessibilities } from '../../../utils/checkRolesAccessibilities';
import VerificationModal from '../../deals/stripeIdentification/VerificationModal';
import { setVerification } from '../../../redux/verification/action';
import dayjs from 'dayjs';

const LeadsTable = ({
	// parent props
	leads,
	search,
	handleEditLead,
	handleDeleteLead,
	anchorEl,
	setAnchorEl,
	filteredLeads,
	setFilteredLeads,
	// redux
	salesAgents,
	modals,
	loading,
	rolesAccessibilities,
	leadsFilter,
	userType,
	getSalesAgents,
	openModal,
	closeModal,
	setVerification,
}) => {
	const [page, setPage] = useState(0);
	const [dense, setDense] = useState(false);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [order, setOrder] = useState('desc');
	const [orderBy, setOrderBy] = useState('createTimestamp');
	const [leadsList, setLeadsList] = useState();
	const [showManage, setShowManage] = useState();
	const [assignSalesAgentsDropdown, setAssignSalesAgentsDropdown] = useState(
		{}
	);
	const [scheduleMeetLoading, setScheduleMeetLoading] = useState(false);
	const [temporaryIdForDropdown, setTemporaryIdForDropdown] = useState();
	const { ref, isComponentVisible, setIsComponentVisible } =
		useComponentVisible(false);
	const [selectedClient, setSelectedClient] = useState();

	//search functionality
	useEffect(() => {
		getSalesAgents();

		const filtered = getSearchResult();
		setFilteredLeads(filtered);
	}, [search, leads]);

	//filter functionality
	useEffect(() => {
		let filtered = leads;
		if (search?.trim().length > 0) {
			// When search is remained in search box (Bug fix: PB-363)
			filtered = getSearchResult();
		}

		if (leadsFilter.postalCode) {
			filtered = filtered?.filter((lead) =>
				lead?.postalCode
					.substring(0, 3)
					.includes(leadsFilter.postalCode)
			);
		}
		if (leadsFilter.agent?.salesAgentId) {
			filtered = filtered.filter((lead) =>
				lead.salesAgent.includes(leadsFilter.agent.salesAgentId)
			);
		}

		if (leadsFilter.buyerType) {
			filtered = filtered?.filter((lead) =>
				lead?.buyerType.includes(leadsFilter.buyerType)
			);
		}

		if (leadsFilter.source) {
			filtered = filtered?.filter((lead) =>
				lead?.reference.includes(leadsFilter.source)
			);
		}

		console.log('filtered adsc', filtered);
		setFilteredLeads(filtered);
	}, [leadsFilter, leads]);

	const getSearchResult = () => {
		let searchResult =
			leads &&
			leads?.filter(
				(lead) =>
					lead?.email?.toLowerCase().includes(search.toLowerCase()) ||
					lead?.postalCode
						?.toLowerCase()
						.includes(search.toLowerCase()) ||
					lead?.clientFName
						?.toLowerCase()
						.includes(search.toLowerCase()) ||
					lead?.clientLName
						?.toLowerCase()
						.includes(search.toLowerCase()) ||
					lead?.reference
						?.toLowerCase()
						.includes(search.toLowerCase()) ||
					(lead?.clientFName + ' ' + lead?.clientLName)
						?.toLowerCase()
						.includes(search.toLowerCase()) ||
					lead?.salesAgentName
						?.toLowerCase()
						.includes(search?.toLowerCase())
			);
		return searchResult;
	};

	const headCellsSuperAdmin = [
		{ id: 'clientFName', label: 'Name' },
		{ id: 'createTimestamp', label: 'Date' },
		// { id: 'postalCode', label: 'Postal Code' },
		{ id: 'sentEmail', label: 'Status' },
		{ id: 'salesAgentName', label: 'Agent' },
	];

	const headCellsAdmin = [
		{ id: 'clientFName', label: 'Name' },
		{ id: 'createTimestamp', label: 'Date' },
		// { id: 'postalCode', label: 'Postal Code' },
		{ id: 'sentEmail', label: 'Status' },
	];

	const descendingComparator = (a, b, orderBy) => {
		let compareA =
			orderBy === 'createTimestamp'
				? dayjs(a.createTimestamp).unix()
				: a[orderBy];
		let compareB =
			orderBy === 'createTimestamp'
				? dayjs(b.createTimestamp).unix()
				: b[orderBy];
		if (compareB < compareA) {
			return -1;
		} else if (compareB > compareA) {
			return 1;
		}
		return 0;
	};

	const getComparator = (order, orderBy) => {
		console.log('getComparator', order, orderBy);
		return order === 'desc'
			? (a, b) => descendingComparator(a, b, orderBy)
			: (a, b) => -descendingComparator(a, b, orderBy);
	};

	const stableSort = (array, comparator) => {
		console.log('array', array);
		const stabilizedThis = array.map((el, index) => [el, index]);
		console.log('comparator', comparator);
		stabilizedThis.sort((a, b) => {
			const order = comparator(a[0], b[0]);
			console.log('stableSort order', order);
			if (order !== 0) return order;
			return a[1] - b[1];
		});

		console.log('stabilizedThisstabilizedThis', stabilizedThis);
		return stabilizedThis.map((el) => el[0]);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleRequestSort = (property) => {
		console.log('handleRequestSort property', property);
		const isAsc = orderBy === property && order === 'asc';
		setOrder(isAsc ? 'desc' : 'asc');
		setOrderBy(property);
	};

	const handleClickManage = (e) => {
		var id = e.currentTarget.dataset.id;
		setIsComponentVisible(true);

		console.log('handleClickManage id', id);
		setShowManage(id);
		setAnchorEl(e.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleLeadDetails = (key) => {
		openModal('leadDetails');
		setSelectedClient(leads.find((item) => item.leadId === key));
	};

	const openVerificationModal = (leadData, leadId) => {
		setVerification(leadId, leadData, false);
		openModal('verification');
	};

	return (
		<>
			<TableContainer className={styles.leadsTable}>
				<Table>
					<TableHead>
						<TableRow>
							{checkRolesAccessibilities(
								rolesAccessibilities,
								userType,
								'deals',
								'leads',
								0
							) && (
								<>
									{headCellsSuperAdmin.map((headCell) => {
										return (
											<TableCell key={headCell.id}>
												<TableSortLabel
													active={
														orderBy === headCell.id
													}
													direction={
														orderBy === headCell.id
															? order
															: 'asc'
													}
													onClick={() => {
														handleRequestSort(
															headCell.id
														);
													}}
													className={
														styles.header_label
													}
												>
													{headCell.label}
												</TableSortLabel>
											</TableCell>
										);
									})}
								</>
							)}
							{!checkRolesAccessibilities(
								rolesAccessibilities,
								userType,
								'deals',
								'leads',
								0
							) && (
								<>
									{headCellsAdmin.map((headCell) => {
										return (
											<TableCell key={headCell.id}>
												<TableSortLabel
													active={
														orderBy === headCell.id
													}
													direction={
														orderBy === headCell.id
															? order
															: 'asc'
													}
													onClick={() => {
														handleRequestSort(
															headCell.id
														);
													}}
													className={
														styles.header_label
													}
												>
													{headCell.label}
												</TableSortLabel>
											</TableCell>
										);
									})}
								</>
							)}
							<TableCell ref={ref} colSpan={2}>
								<TableSortLabel className={styles.header_label}>
									Contact
								</TableSortLabel>
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{filteredLeads &&
							stableSort(
								filteredLeads.slice().reverse(),
								getComparator(order, orderBy)
							)
								.slice(
									page * rowsPerPage,
									page * rowsPerPage + rowsPerPage
								)
								.map((row, index) => {
									return (
										<LeadsItem
											// key={row.email}
											key={row.leadId || row.leadsKey}
											row={row}
											index={index}
											styles={styles}
											showManage={showManage}
											setShowManage={setShowManage}
											handleClickManage={
												handleClickManage
											}
											isComponentVisible={
												isComponentVisible
											}
											ref={ref}
											setIsComponentVisible={
												setIsComponentVisible
											}
											salesAgents={salesAgents}
											assignSalesAgentsDropdown={
												assignSalesAgentsDropdown
											}
											setAssignSalesAgentsDropdown={
												setAssignSalesAgentsDropdown
											}
											handleEditLead={handleEditLead}
											handleDeleteLead={handleDeleteLead}
											handleClose={handleClose}
											anchorEl={anchorEl}
											temporaryIdForDropdown={
												temporaryIdForDropdown
											}
											setTemporaryIdForDropdown={
												setTemporaryIdForDropdown
											}
											handleLeadDetails={
												handleLeadDetails
											}
										/>
									);
								})}
					</TableBody>
				</Table>
				<TablePagination
					rowsPerPageOptions={[5, 10, 50]}
					component='div'
					count={leads.length}
					rowsPerPage={rowsPerPage}
					page={page}
					onPageChange={handleChangePage}
					onRowsPerPageChange={handleChangeRowsPerPage}
					style={{
						marginTop: '25px',
					}}
					labelRowsPerPage={
						<div style={{ color: 'var(--text-high-emphasis)' }}>
							Rows per page
						</div>
					}
					nextIconButtonProps={{
						style: {
							padding: '0px',
						},
					}}
					backIconButtonProps={{
						style: {
							padding: '0px',
							marginLeft: '-10px',
						},
					}}
					SelectProps={{
						style: {
							border: '1px solid var(--text-mid-emphasis)',
							borderRadius: '4px',
							padding: '4px',
							marginRight: '10px',
						},
					}}
				/>
			</TableContainer>

			<LeadDetailsModal
				showModal={modals.leadDetails}
				lead={selectedClient}
				openVerificationModal={openVerificationModal}
				handleEditLead={handleEditLead}
			/>
			<VerificationModal
				showModal={modals.verification}
				// closeModal={() => closeModal('verification')}
				closeModal={handleLeadDetails}
				node='lead'
			/>
			<ScheduleMeeting
				showModal={modals.scheduleMeeting}
				setLoading={setScheduleMeetLoading}
				handleScheduleModalClose={handleLeadDetails}
				hasPreviousModal={true}
			/>
		</>
	);
};

const mapStateToProps = (state) => ({
	salesAgents: state.leads.salesAgents,
	modals: state.modals,
	loading: state.leads.loading,
	leadsFilter: state.filters.leadsFilter,
	userType: state.signIn.userType,
	rolesAccessibilities: state.userManagement.rolesAccessibilities,
});

export default connect(mapStateToProps, {
	getSalesAgents,
	openModal,
	closeModal,
	setVerification,
})(LeadsTable);
